export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.documentTemplates.index(payload);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function findTemplateById({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.documentTemplates.show(payload);
  if (!errResponse && responseData.success) {
    return commit('setDocumentTemplate', responseData.data);
  }
  return [];
}

export async function create({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.documentTemplates.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function update({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.documentTemplates.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function destroy(_, id) {
  return this.$adminRepositories.documentTemplates.delete(id);
}

